module.exports = __webpack_public_path__ + "img/jt03.2105c862.png";